<template>
    <div class="shell-wrapper">
        <div class="shell">
            <aside class="aside">
                <div class="logo">
                    <div class="logo-mark">
                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
                            <path
                                d="M9 1.5L2.25 4.5v5.25c0 4.05 2.9 7.84 6.75 8.75 3.85-.91 6.75-4.7 6.75-8.75V4.5L9 1.5z"
                                fill="white" opacity="0.9" />
                        </svg>
                    </div>
                    <span class="logo-name">{{ modalSuccessFakePsp.name }}</span>
                </div>
                <div class="aside-secure">
                    <svg width="13" height="13" viewBox="0 0 13 13" fill="none">
                        <path d="M6.5 1L1 3.5v4.25C1 11.1 3.57 14.3 6.5 15c2.93-.7 5.5-3.9 5.5-7.25V3.5L6.5 1z"
                            stroke="#7A8BAD" stroke-width="1.15" fill="none" />
                        <path d="M4 6.5l2 2 3-3" stroke="#7A8BAD" stroke-width="1.15" stroke-linecap="round"
                            stroke-linejoin="round" />
                    </svg>
                    Your data is encrypted. We do not store payment information.
                </div>
            </aside>
            <main class="main">
                <div class="state" :class="{ active: processing, 'fade-out': fadeOut }" id="stateProcessing">
                    <svg class="spin-arrows" width="88" height="88" viewBox="0 0 64 64" fill="none">
                        <path d="M 56 32 A 24 24 0 0 1 17.02 50.77" stroke="#3B6FE8" stroke-width="3.5"
                            stroke-linecap="round" />
                        <polygon points="0,0 -10,-5.5 -10,5.5" fill="#3B6FE8"
                            transform="translate(11.22,44) rotate(240)" />
                        <path d="M 8 32 A 24 24 0 0 1 46.98 13.23" stroke="#3B6FE8" stroke-width="3.5"
                            stroke-linecap="round" />
                        <polygon points="0,0 -10,-5.5 -10,5.5" fill="#3B6FE8"
                            transform="translate(52.78,20) rotate(60)" />
                    </svg>
                    <div class="proc-label">Processing</div>
                    <div class="proc-dots">
                        <span class="dot"></span>
                        <span class="dot"></span>
                        <span class="dot"></span>
                    </div>
                </div>
                <div class="state state-success" :class="{ active: success, show: success }" id="stateSuccess">
                    <div class="check-wrap">
                        <div class="ring"></div>
                        <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
                            <path class="check-path" d="M12 24l9 9 15-15" stroke="#2A825A" stroke-width="3.2"
                                stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </div>
                    <div class="approved-title">Transaction Approved!</div>
                </div>
            </main>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    data() {
        return {
            processing: true,
            fadeOut: false,
            success: false
        };
    },

    computed: {
        ...mapGetters(["modalSuccessFakePsp"])
    },

    mounted() {
        setTimeout(() => {
            this.fadeOut = true;

            setTimeout(() => {
                this.processing = false;
                this.success = true;
            }, 380);

        }, this.modalSuccessFakePsp.timing);
    }
};
</script>

<style scoped>
.shell-wrapper {
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', system-ui, sans-serif;
    background: var(--bg);
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 24px;
    position: fixed;
    inset: 0;
    z-index: 10000;
    --bg: #EEF0F7;
    --navy: #1B2740;
    --panel-text: #E4E9F4;
    --panel-muted: #7A8BAD;
    --white: #FFFFFF;
    --text: #1B2740;
    --text-muted: #6B7590;
    --accent: #3B6FE8;
    --success: #2A825A;
}

.shell {
    display: flex;
    width: 100%;
    max-width: 900px;
    background: var(--white);
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 10px 48px rgba(27, 39, 64, 0.14);
    min-height: 420px;
}

.aside {
    width: 260px;
    flex-shrink: 0;
    background: var(--navy);
    padding: 44px 32px;
    display: flex;
    flex-direction: column;
}

.logo {
    display: flex;
    align-items: center;
    gap: 10px;
}

.logo-mark {
    width: 36px;
    height: 36px;
    background: var(--accent);
    border-radius: 9px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.logo-name {
    color: var(--panel-text);
    font-size: 16px;
    font-weight: 700;
    letter-spacing: -0.2px;
}

.aside-secure {
    margin-top: auto;
    display: flex;
    align-items: flex-start;
    gap: 9px;
    color: var(--panel-muted);
    font-size: 11.5px;
    line-height: 1.55;
    font-weight: 400;
}

.aside-secure svg {
    flex-shrink: 0;
    margin-top: 1px;
}

.main {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 0;
}

.state {
    display: none;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    gap: 20px;
    padding: 48px 40px;
    width: 100%;
}

.state.active {
    display: flex;
}

.spin-arrows {
    animation: spin 1.4s linear infinite;
    transform-box: fill-box;
    transform-origin: center;
    overflow: visible;
}

@keyframes spin {
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
}

.proc-label {
    font-size: 18px;
    font-weight: 700;
    color: var(--text);
    letter-spacing: 0.03em;
    margin-top: 4px;
}

.proc-dots {
    display: flex;
    gap: 7px;
    align-items: center;
    margin-top: -6px;
}

.dot {
    width: 7px;
    height: 7px;
    background: var(--accent);
    border-radius: 50%;
    opacity: 0.35;
    animation: dotPulse 1.4s ease-in-out infinite;
}

.dot:nth-child(2) {
    animation-delay: 0.22s;
}

.dot:nth-child(3) {
    animation-delay: 0.44s;
}

@keyframes dotPulse {

    0%,
    80%,
    100% {
        opacity: 0.25;
        transform: scale(0.85);
    }

    40% {
        opacity: 1;
        transform: scale(1.15);
    }
}

.fade-out {
    animation: fadeOut 0.35s ease forwards !important;
}

@keyframes fadeOut {
    from {
        opacity: 1;
        transform: translateY(0);
    }

    to {
        opacity: 0;
        transform: translateY(8px);
    }
}

.state-success.show {
    animation: fadeUp 0.4s ease both;
}

@keyframes fadeUp {
    from {
        opacity: 0;
        transform: translateY(12px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.check-wrap {
    position: relative;
    width: 96px;
    height: 96px;
}

.check-wrap .ring {
    position: absolute;
    inset: 0;
    width: 96px;
    height: 96px;
    border-radius: 50%;
    background: rgba(42, 130, 90, 0.1);
    border: 2.5px solid rgba(42, 130, 90, 0.3);
    animation: popIn 0.45s cubic-bezier(0.34, 1.56, 0.64, 1) both;
}

@keyframes popIn {
    from {
        transform: scale(0.4);
        opacity: 0;
    }

    to {
        transform: scale(1);
        opacity: 1;
    }
}

.check-wrap svg {
    position: absolute;
    inset: 0;
    margin: auto;
}

.check-path {
    stroke-dasharray: 40;
    stroke-dashoffset: 40;
    animation: drawCheck 0.45s 0.35s ease forwards;
}

@keyframes drawCheck {
    to {
        stroke-dashoffset: 0;
    }
}

.approved-title {
    font-size: 24px;
    font-weight: 400;
    color: #303030;
    line-height: 1.2;
    margin-top: 6px;
}

@media (max-width: 680px) {
    body {
        padding: 0;
        align-items: flex-start;
    }

    .shell {
        flex-direction: column;
        border-radius: 0;
        min-height: 100dvh;
    }

    .aside {
        width: 100%;
        padding: 26px 22px;
    }

    .aside-secure {
        margin-top: 20px;
    }
}

@media (prefers-reduced-motion: reduce) {

    *,
    *::before,
    *::after {
        animation: none !important;
    }
}
</style>